import React from "react";
import Dialog from "components/Overlays/ResponsiveDialog";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { BsExclamationTriangle } from "react-icons/bs";

/**
 * Modal confirmation for cancelling a bulk book import.
 */
const CancelImportDialog = ({
	visible,
	onHide,
	onConfirm,
	busy = false,
}) => {
	const footer = (
		<div className="flex flex-wrap justify-end gap-2 pt-2">
			<button
				type="button"
				className="rounded-lg border border-gray-200 bg-white px-4 py-2.5 text-sm font-medium text-gray-700 transition hover:bg-gray-50 disabled:opacity-50"
				onClick={onHide}
				disabled={busy}
			>
				Keep import
			</button>
			<button
				type="button"
				className="inline-flex portal-control-height items-center justify-center gap-2 rounded-lg bg-red-600 px-5 py-2.5 text-sm font-semibold text-white shadow-sm transition hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 disabled:opacity-50"
				onClick={onConfirm}
				disabled={busy}
			>
				{busy ? (
					<>
						<AiOutlineLoading3Quarters
							className="h-4 w-4 animate-spin"
							aria-hidden
						/>
						Cancelling…
					</>
				) : (
					"Cancel import"
				)}
			</button>
		</div>
	);

	return (
		<Dialog sheet={false}
			visible={visible}
			onHide={() => {
				if (!busy) onHide();
			}}
			header="Cancel this import?"
			footer={footer}
			modal
			draggable={false}
			resizable={false}
			style={{ width: "min(28rem, 92vw)" }}
			className="font-sans"
			closable={!busy}
			closeOnEscape={!busy}
		>
			<div className="flex gap-3 py-1">
				<span className="mt-0.5 flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-red-50 text-red-600">
					<BsExclamationTriangle className="h-5 w-5" aria-hidden />
				</span>
				<div className="space-y-2 text-sm leading-relaxed text-gray-600">
					<p>
						Processing will stop for this batch. You can start a new
						bulk upload afterward.
					</p>
					<p className="text-gray-500">
						Files already attached to books are kept. Staged uploads
						for this import will no longer be processed.
					</p>
				</div>
			</div>
		</Dialog>
	);
};

export default CancelImportDialog;
